import api from "@/lib/api";
import { toast } from "sonner";

export async function baixarPdf(url, nome) {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = nome; a.click(); URL.revokeObjectURL(u);
  } catch { toast.error("Não foi possível gerar o PDF"); }
}
